var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dash-content-outer col" }, [
    _c("div", { staticClass: "head" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Monetization")]),
      _vm._v(" "),
      _c("div", { staticClass: "actns" }, [
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$parent.openPlanOverlay.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "ico" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "26",
                    height: "26",
                    viewBox: "0 0 26 26",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                      fill: "black",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [
              _vm._v("New Subscription plan"),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "inner-content" }, [
      _c(
        "div",
        { staticClass: "all-plans" },
        [
          _c(
            "div",
            {
              staticClass: "plan-preview col",
              class: [
                "radius" + _vm.Global.mockupConfig.radiusRatio,
                _vm.Global.mockupConfig.activeFont,
              ],
            },
            [
              _c("div", { staticClass: "preview col" }, [
                _c(
                  "h5",
                  { style: { color: _vm.Global.mockupConfig.colors.icons } },
                  [_vm._v("Free")]
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c(
                      "span",
                      {
                        staticClass: "ico",
                        style: {
                          background: _vm.Global.mockupConfig.colors.icons,
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                              fill: "none",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                y: "10.6067",
                                width: "3",
                                height: "10",
                                transform: "rotate(-45 0 10.6067)",
                                fill: "black",
                              },
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                width: "3",
                                height: "15",
                                transform:
                                  "matrix(0.707103 0.70711 -0.707103 0.70711 15.5562 4.94971)",
                                fill: "black",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "txt" }, [
                      _vm._v("Free content"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "ico x" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "22",
                            height: "22",
                            viewBox: "0 0 22 22",
                            fill: "none",
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              width: "3",
                              height: "15",
                              transform:
                                "matrix(0.707103 0.70711 -0.707103 0.70711 15.249 4.63589)",
                              fill: "white",
                            },
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              width: "3",
                              height: "15",
                              transform:
                                "matrix(0.707107 -0.707107 0.707114 0.7071 4.64258 6.75729)",
                              fill: "white",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "txt" }, [
                      _vm._v("Premium contents"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "ico x" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "22",
                            height: "22",
                            viewBox: "0 0 22 22",
                            fill: "none",
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              width: "3",
                              height: "15",
                              transform:
                                "matrix(0.707103 0.70711 -0.707103 0.70711 15.249 4.63589)",
                              fill: "white",
                            },
                          }),
                          _vm._v(" "),
                          _c("rect", {
                            attrs: {
                              width: "3",
                              height: "15",
                              transform:
                                "matrix(0.707107 -0.707107 0.707114 0.7071 4.64258 6.75729)",
                              fill: "white",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "txt" }, [
                      _vm._v("Downloads for offline watch"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn main",
                    style: { background: _vm.Global.mockupConfig.colors.icons },
                  },
                  [
                    _c("span", { staticClass: "txt" }, [
                      _vm._v("Get free account"),
                    ]),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.Global.plans[1]
            ? _c("PlanCard", { attrs: { plan: _vm.Global.plans[1] } })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "ft-bld txt-ctr" }, [
      _vm._v("Free content, advertising to"),
      _c("br"),
      _vm._v(" support us"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }